import React,{useContext,useEffect} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    
    Hidden,
} from '@material-ui/core';
import { Coin } from '../component'
import StudentContext from '../../../context/student-context';
import useStyles from './styles'
import clsx from 'clsx'
import { getIconProfile, getIconDrawer } from '../../../utils/helpers/icon/iconHelper';

export default function DialogLearningContent(props) {
    const classes = useStyles()
    const [avatar,setAvatar] = React.useState('');    
    const {
        coinEarn,
        coinBalance,
        open,
        handleCatalogClick,
        handleRedoClick,
        handleRewatchClick,
        code,
        message,
        titleContent = '',
        isNotFullMarks = false
    } = props
    const {studentContext} = useContext(StudentContext);

    useEffect(()=>{
        if(studentContext){
            let toReturn = "";
            switch(studentContext.dinosaur.cluster){
                case 'ICT':
                    studentContext.dinosaur.level > 0 ?
                        toReturn = getIconProfile().img_profile_ict : toReturn = getIconProfile().img_profile_ict_egg;
                    break;
                case 'CEFT':
                    studentContext.dinosaur.level > 0 ?
                        toReturn = getIconProfile().img_profile_ceft : toReturn = getIconProfile().img_profile_ceft_egg;
                    break;
                case 'DSB':
                    studentContext.dinosaur.level > 0 ?
                        toReturn = getIconProfile().img_profile_dsb : toReturn = getIconProfile().img_profile_dsb_egg;
                    break;
                case 'HSS':
                    studentContext.dinosaur.level > 0 ?
                        toReturn = getIconProfile().img_profile_hss : toReturn = getIconProfile().img_profile_hss_egg;
                    break;
                default:
                    studentContext.dinosaur.level > 0 ?
                        toReturn = getIconProfile().img_profile_ict : toReturn = getIconProfile().img_profile_ict_egg;
                    break;                                                    
            }
            setAvatar(toReturn);
        }else{
            setAvatar(getIconProfile().img_profile_ict_egg);
        }
    },[])

    return (
        <Dialog
            classes={{ root: classes.rootDialog, paperWidthFalse: classes.rootPaperWidthFalse }}
            maxWidth={false}
            open={open}
        >
            <DialogTitle disableTypography={true} classes={{ root: classes.rootDialogTitle }}>{"Thank you"}</DialogTitle>
            <DialogContent>
                <Grid 
                    container
                    direction="column"
                    alignItems="center"
                    justify="center"
                    classes={{ root: classes.rootGridContent }}
                >
                    {code !== '' &&
                        <div className={clsx( classes.code, coinEarn > 0 ? classes.codeSuccess : classes.codeFail)}>{code}</div>
                    }
                    {titleContent !== '' &&
                        <div className={classes.titleContent}>{titleContent}</div>
                    }
                    <Grid container direction = "row">                        
                        <Grid item xs={8}>
                            <div className={classes.message}>{message}</div>
                        </Grid>
                        <Grid item xs={4}>
                            <div className={classes.containerImageUser}>
                                <img src={avatar} alt="avatar" className={classes.imageUser} 
                                />
                            </div>
                        </Grid>
                    </Grid>
                    
                </Grid>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justify="center"
                    classes={{ root: classes.rootGrid }}
                >
                    
                    <Grid item xs={6} sm={6} container justify="center" alignItems="center">
                        <div>
                            <Hidden smDown>
                                <Coin size="medium" coin={`+${coinEarn}`}/>
                            </Hidden>
                            <Hidden mdUp>
                                <Coin size="small" coin={`+${coinEarn}`}/>
                            </Hidden>
                        </div>
                        <div className={classes.textContent}>Coins Earned</div>
                    </Grid>
                    <Grid item xs={6} sm={6} container justify="center" alignItems="center">
                        <div>
                            <Hidden smDown>
                                <Coin size="medium" coin={coinBalance}/>
                            </Hidden>
                            <Hidden mdUp>
                                <Coin size="small" coin={coinBalance}/>
                            </Hidden>
                        </div>
                        <div className={classes.textContent}>New Balance</div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions classes={{ root: classes.rootDialogActions }}>
                <Button onClick={handleCatalogClick} autoFocus classes={{ root: classes.rootButtonAgree }}>
                    To Content List
                </Button>
                { isNotFullMarks &&
                <div>
                    <Button 
                    classes={{ root: classes.rootButtonAgree }}
                    onClick = {handleRewatchClick}
                    >Re-view</Button>
                    <Button
                    classes={{ root: classes.rootButtonAgree }}
                    onClick = {handleRedoClick}
                    >Redo</Button>
                </div>
                }
            </DialogActions>
        </Dialog>
    );
}